import React, { useState, useEffect } from 'react'
import { Button, Pagination, Select, Spin } from 'antd'
import CombinedSetStatisticsTable from './ReuseEmbroideryInfoTable'
import ModalBulkDeleteReuseEmbroidery from './ModalBulkDeleteReuseEmbroidery'
import { getReuseEmbroideryInfo } from '../../../services/api/3dApi'
import qs from "qs"
import UseDebounce from '../../users/helpers/UseDebounce'

const ReuseEmbroideryInfoPage = (props) => {
    const { params = {} } = props
    const { barcode = '' } = params

    const [data, setData] = useState([])
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [searchBarcodes, setSearchBarcodes] = useState(barcode ? [barcode] : [])
    const [loading, setLoading] = useState(false)
    const [selectedRowIds, setSelectedRowIds] = useState([])
    const [isOpenBulkDelete, setIsOpenBulkDelete] = useState(false)

    const searchBarcodesStr = JSON.stringify(searchBarcodes)
    const searchBarcodesDebounce = UseDebounce(searchBarcodesStr, searchBarcodes.length === 0 ? 0 : 500)

    const handlePageChange = (current) => {
        setPage(current)
    }

    const handleShowSizeChange = (current, size) => {
        setPage(1)
        setLimit(size)
    }

    const _fetchData = async () => {
        setLoading(true)
        setError('')
        try {
            const payload = {
                query: {},
                page, limit
            }
            const barcodes = JSON.parse(searchBarcodesDebounce)
            const cleaned = barcodes.map(b => b.replace('#', '').trim()).filter(Boolean)
            if (cleaned.length > 0) payload.query.origin_barcodes = cleaned.join(', ')

            const { data: res } = await getReuseEmbroideryInfo(qs.stringify(payload))
            const { data, success, message: mess } = res
            if (!success) throw new Error(mess)

            const { rows = [], total: newTotal = 0 } = { ...data }
            setTotal(newTotal)
            setData(rows)

        } catch (error) {
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        setSelectedRowIds([])
        _fetchData()
    }, [page, limit, searchBarcodesDebounce]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className='ReuseEmbroideryInfoPage'>
            <div className='container-fluid min-vh-100'>
                <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                    <div className='mb-3 d-flex justify-content-between mt-3'>
                        <h3 className='mb-0'>Danh sách các thiết kế thêu gốc</h3>
                    </div>
                    <div className='jumbotron p-3 mb-3'>
                        <div className='row align-items-start'>
                            <div className='col-4'>
                                <label className='font-weight-bold mb-1'>Mã đơn:</label>
                                <Select
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    placeholder="Tìm theo mã đơn..."
                                    tokenSeparators={[' ']}
                                    value={searchBarcodes}
                                    onChange={(values) => {
                                        setSearchBarcodes(values)
                                        setPage(1)
                                    }}
                                    allowClear
                                    open={false}
                                    suffixIcon={null}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && <div className='text-danger'>{error}</div>}
                        </div>
                        {selectedRowIds.length > 0 && (
                            <div className="d-flex align-items-center">
                                <span className="mr-3">Đã chọn <b>{selectedRowIds.length}</b> mã đơn</span>
                                <Button type="danger" onClick={() => setIsOpenBulkDelete(true)}>Xóa</Button>
                            </div>
                        )}
                    </div>
                    <Spin spinning={loading} tip='Loading...'>
                        <CombinedSetStatisticsTable
                            data={data}
                            loading={loading}
                            reload={_fetchData}
                            selectedRowIds={selectedRowIds}
                            setSelectedRowIds={setSelectedRowIds}
                        />
                    </Spin>
                    <ModalBulkDeleteReuseEmbroidery
                        visible={isOpenBulkDelete}
                        selectedItems={data.filter(d => selectedRowIds.includes(d._id))}
                        onClose={() => {
                            setIsOpenBulkDelete(false)
                            setSelectedRowIds([])
                        }}
                        onDone={() => {
                            setIsOpenBulkDelete(false)
                            setSelectedRowIds([])
                            _fetchData()
                        }}
                    />
                    <Pagination
                        current={page}
                        total={total}
                        pageSize={limit}
                        className='text-right'
                        showSizeChanger
                        showQuickJumper
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        onShowSizeChange={handleShowSizeChange}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    )
}

export default ReuseEmbroideryInfoPage